import { useSelector } from "react-redux";
import { useState, useEffect, useMemo } from "react";
import { walkthroughStateSelect } from "Layout/slice/selector";
import { USER_FLAGS } from "utils/constants";
import { useConnectedAccounts } from "features/Dashboard/hook/useConnectedAccounts";

// Internal constants
const BROKER_SURMOUNT = "SURMOUNT";
const ALPACA_STATUS = {
  CONFIRMED: "confirmed",
  PENDING: "pending",
};

export const useSurmountAccountStatus = () => {
  const [show, setShow] = useState(false);

  const userFlags = useSelector(walkthroughStateSelect);

  const { portfolios, isLoading: isPortfolioLoading } = useConnectedAccounts();
  const surmountPortfolio = portfolios?.find(
    (account) => account.broker === BROKER_SURMOUNT
  );

  const activeFlags = useMemo(() => {
    return (userFlags || []).reduce((acc, { flag, is_active }) => {
      acc[flag] = is_active;
      return acc;
    }, {});
  }, [userFlags]);

  const isBankConnected = activeFlags[USER_FLAGS.CONNECTED_TO_BANK];
  const isOnboardCompleted =
    activeFlags[USER_FLAGS.INTERNAL_ONBOARDING_COMPLETED];
  const isFundingDeclared = activeFlags[USER_FLAGS.HAS_DEPOSITED];

  const checkFlag = (flag) => activeFlags[flag] || false;

  const isApproved =
    surmountPortfolio?.authentication_status === ALPACA_STATUS.CONFIRMED;

  const hasPendingSurmountAccount = portfolios?.some(
    (account) =>
      account.broker === BROKER_SURMOUNT &&
      account.authentication_status === ALPACA_STATUS.PENDING
  );

  const isAllStepsCompleted =
    isBankConnected &&
    // isOnboardCompleted && // optional
    isFundingDeclared &&
    isApproved;

  useEffect(() => {
    if (!userFlags || userFlags.length === 0) {
      setShow(false);
      return;
    }

    if (isPortfolioLoading) return;

    if (!surmountPortfolio) {
      setShow(false);
      return;
    }
    const shouldShow =
      !isAllStepsCompleted && surmountPortfolio && !isPortfolioLoading;
    setShow(shouldShow);
  }, [isAllStepsCompleted, surmountPortfolio, isPortfolioLoading, userFlags]);

  return {
    surmountPortfolio,
    userFlags,
    isBankConnected,
    isOnboardCompleted,
    isFundingDeclared,
    isApproved,
    hasPendingSurmountAccount,
    isAllStepsCompleted,
    show,
    setShow,
    checkFlag,
    isLoading: isPortfolioLoading,
  };
};
